export const FooterFixed = () => {
  return (
    <div style={{ position: 'fixed', bottom: '25px', width: '80%' }} id='footer' className='app-footer mx-0 px-0 mb-100px'>
      &copy; 2026 Metropolitan Chess Center - Dindin All Rights Reserved
    </div>
  )
}
